import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Trades, HowItWorks, HonestColumns, Priority } from "@/components/Sections";
import { ApplySection } from "@/components/ApplySection";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Trades />
        <HowItWorks />
        <HonestColumns />
        <Priority />
        <ApplySection />
      </main>
      <Footer />
    </div>
  );
}
